var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64694 5.61109C5.1562 6.01369 4.75 6.7595 4.75 8.25V18C4.75 19.3465 5.14588 20.1121 5.66144 20.5574C6.19756 21.0203 6.99287 21.25 8 21.25H16C17.0071 21.25 17.8024 21.0203 18.3386 20.5574C18.8541 20.1121 19.25 19.3465 19.25 18V8.25C19.25 6.7595 18.8438 6.01369 18.3531 5.61109C17.9453 5.27655 17.3767 5.09163 16.648 5.02683C16.3049 6.3057 15.1357 7.25 13.75 7.25H10.25C9.42284 7.25 8.67436 6.91504 8.12964 6.37033C7.76186 6.00254 7.48972 5.54189 7.35173 5.02685C6.62315 5.09167 6.05468 5.27659 5.64694 5.61109ZM4.69556 4.45141C5.62138 3.69188 6.8366 3.5 8 3.5C8.41421 3.5 8.75 3.83579 8.75 4.25C8.75 4.66286 8.91503 5.03439 9.1903 5.30967C9.46559 5.58495 9.83716 5.75 10.25 5.75H13.75C14.5758 5.75 15.25 5.07579 15.25 4.25C15.25 3.83579 15.5858 3.5 16 3.5C17.1634 3.5 18.3786 3.69188 19.3044 4.45141C20.2612 5.23631 20.75 6.4905 20.75 8.25V18C20.75 19.6535 20.2509 20.8879 19.3189 21.6926C18.4076 22.4797 17.2029 22.75 16 22.75H8C6.79713 22.75 5.59244 22.4797 4.68106 21.6926C3.74912 20.8879 3.25 19.6535 3.25 18V8.25C3.25 6.4905 3.7388 5.23631 4.69556 4.45141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 2.75C9.42421 2.75 8.75 3.42421 8.75 4.25C8.75 4.66286 8.91503 5.03439 9.1903 5.30967C9.46559 5.58495 9.83716 5.75 10.25 5.75H13.75C14.5758 5.75 15.25 5.07579 15.25 4.25C15.25 3.83714 15.085 3.46561 14.8097 3.19033C14.5344 2.91505 14.1628 2.75 13.75 2.75H10.25ZM7.25 4.25C7.25 2.59579 8.59579 1.25 10.25 1.25H13.75C14.5772 1.25 15.3256 1.58496 15.8704 2.12967C16.4151 2.6744 16.75 3.42286 16.75 4.25C16.75 5.90421 15.4042 7.25 13.75 7.25H10.25C9.42284 7.25 8.67436 6.91504 8.12964 6.37033C7.58492 5.8256 7.25 5.07714 7.25 4.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H12C12.4142 12.25 12.75 12.5858 12.75 13C12.75 13.4142 12.4142 13.75 12 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideline);
export default __webpack_public_path__ + "static/media/guideline.e5d38e7a0bc06f2fe7560cef3d7af08d.svg";
export { ForwardRef as ReactComponent };